import { createSlice } from '@reduxjs/toolkit';
import { fetchCategories } from '../actions/categoryActions';

const initialState = {
  categories: [],
  loading: false,
  error: null,
  status: 'idle',
};

const categorySlice = createSlice({
  name: 'category',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.status = 'loading';
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.loading = false;
        state.categories = action.payload;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { clearError } = categorySlice.actions;

// Selectors
export const selectCategories = (state) => state.category.categories;
export const selectCategoriesLoading = (state) => state.category.loading;
export const selectCategoriesError = (state) => state.category.error;

export default categorySlice.reducer;
